"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var locales_1 = require("../locales");
var Button = function (_a) {
    var scope = _a.scope, buttonType = _a.buttonType, callback = _a.callback, disabled = _a.disabled, width = _a.width, style = _a.style, language = _a.language, children = _a.children;
    var ll_CC = language || (0, locales_1.getNavigatorLanguage)();
    var label = buttonType || "continue_with";
    (0, react_1.useEffect)(function () {
        if (typeof window !== "undefined" && (window === null || window === void 0 ? void 0 : window.FB)) {
            window.FB.Event.subscribe("auth.statusChange", function () {
                window.FB.getLoginStatus(function (res) {
                    if (res.authResponse && res.status === "connected")
                        callback(res.authResponse);
                });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleClick = function () {
        if (typeof window !== "undefined" && (window === null || window === void 0 ? void 0 : window.FB)) {
            window.FB.login(function (res) {
                if (res.status === "connected")
                    callback(res.authResponse);
                else
                    console.warn("User cancelled login or did not fully authorize.");
            }, { scope: scope });
        }
    };
    return (react_1["default"].createElement("div", { className: "fb-login-button", style: tslib_1.__assign({ width: "100%", display: "flex", placeContent: "center", placeItems: "center" }, style) }, children ? (react_1["default"].createElement("div", { style: {
            width: width || "inherit"
        }, onClick: typeof window === "undefined" || disabled ? undefined : handleClick }, children)) : (react_1["default"].createElement("button", { className: "fb-button-main-element", "aria-label": locales_1.labels[ll_CC][label], style: {
            fontSize: 16,
            fontWeight: "normal",
            height: 32,
            width: width || "fit-content",
            border: 0,
            borderRadius: 4,
            backgroundColor: "rgb(26, 119, 242)",
            color: "rgb(255, 255, 255)",
            display: "flex",
            justifyContent: "flex-start",
            placeItems: "center",
            opacity: typeof window === "undefined" || disabled ? 0.5 : 1,
            cursor: typeof window === "undefined" || disabled
                ? "not-allowed"
                : "pointer"
        }, disabled: typeof window === "undefined" || disabled, onClick: handleClick },
        react_1["default"].createElement("span", { className: "fb_button_label_element fb_button_label", style: {
                width: "100%",
                margin: "0 8px",
                display: "flex",
                placeContent: "center",
                placeItems: "center"
            } },
            react_1["default"].createElement("svg", { style: {
                    height: 20,
                    marginRight: 10
                }, viewBox: "0 0 213 213", preserveAspectRatio: "xMinYMin", className: "fb_button_svg_logo login_fb_logo single_button_svg_logo" },
                react_1["default"].createElement("path", { d: "M90,212v-75h-27v-31h27v-25q0,-40 40,-40q15,0 24,2v26h-14q-16,0 -16,16v21h30l-5,31h-27v75a106 106,0,1,0,-32 0", className: "f_logo_circle", fill: "white" }),
                react_1["default"].createElement("path", { d: "M90,212v-75h-27v-31h27v-25q0,-40 40,-40q15,0 24,2v26h-14q-16,0 -16,16v21h30l-5,31h-27v75a106 106,1,0,1,-32 0", className: "f_logo_f", fill: "rgb(26, 119, 242)" })),
            react_1["default"].createElement("span", null, locales_1.labels[ll_CC][label]))))));
};
exports["default"] = Button;
//# sourceMappingURL=Button.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@tusken-s/facebook-tools/dist/cjs/components/Button.js
// module id = 217
// module chunks = 168707334958949